import axios from "axios"
// import { IKiz2DocumentGetDTO } from "../../coreapi-dto/dirs/kiz";

import { IRequestForMovementGetDTO } from '../../coreapi-dto/documents/requestForMovement'

import { envF } from "../../../env"
import { IRequestForMovementItemEditDTO, IRequestForMovementItemGetDTO } from '../../coreapi-dto/documents/requestForMovementItem'

export const getRequestForMovementItemEditDTO = async (idDocument: string, callback: (e) => void) => {

    const jwtToken = localStorage.getItem("TokenData") as string;
    const token = `Bearer ${JSON.parse(jwtToken).accessToken}`;
    const header = {
        headers: {
            Authorization: token
        },
    }

    // const generateKizRequestUrl = (idDocumentItem) => {
    //     return `${envF.REACT_APP_API_GATEWAY_PATH}/Kiz/Document/${idDocument}/Item/${idDocumentItem}`
    // }

    const generateRequestForMovementRequestUrl = () => {
        return `${envF.REACT_APP_API_GATEWAY_PATH}/RequestForMovement/${idDocument}`
    }

    let RequestForMovement = await axios.get<IRequestForMovementGetDTO>(
        generateRequestForMovementRequestUrl(),
        header
    )

    let items: IRequestForMovementItemEditDTO[] = []

    const itemsPush = async (x: IRequestForMovementItemGetDTO) => {
        // if (!x.isKiz) {
        //     items.push({
        //         idGlobal: x.idGlobal as string,
        //         goodsName: x?.goods?.displayName ?? undefined,
        //         supplierCostInfo: x.supplierCostInfo,
        //         retailCostInfo: x.retailCostInfo,
        //         isKiz: x.isKiz,
        //         quantity: x.quantity,
        //         dateCreated: x.dateCreated,
        //         idLotExternalGlobal: x?.lot?.idGlobal ?? undefined,
        //         idGoodsExternalGlobal: x?.goods?.idGlobal ?? undefined,
        //         goodsCode: x.goodsCode,
        //         price: x.price,
        //         scPaid: x.scPaid,
        //         producerName: x.producerName ?? undefined,
        //         isGnvls: x.isGnvls,
        //         kizCount: x.kizCount,
        //         internalBarcode: x?.internalBarcode ?? undefined,
        //         incomeSource: x.incomeSource,
        //         isgRequest: x.isgRequest,
        //         bestBeforeRequest: x.bestBeforeRequest,
        //         retailPriceInStocks: x.retailPriceInStocks
        //     })
        // } else {
        //     await axios.get<IKiz2DocumentGetDTO>(
        //         generateKizRequestUrl(x.idGlobal),
        //         header
        //     ).then((e) => {
        //         items.push({
        //             idGlobal: x.idGlobal as string,
        //             goodsName: x?.goods?.displayName ?? undefined,
        //             supplierCostInfo: x.supplierCostInfo,
        //             retailCostInfo: x.retailCostInfo,
        //             isKiz: x.isKiz,
        //             quantity: x.quantity,
        //             dateCreated: x.dateCreated,
        //             idLotExternalGlobal: x?.lot?.idGlobal ?? undefined,
        //             idGoodsExternalGlobal: x?.goods?.idGlobal ?? undefined,
        //             goodsCode: x.goodsCode,
        //             price: x.price,
        //             scPaid: x.scPaid,
        //             producerName: x.producerName ?? undefined,
        //             isGnvls: x.isGnvls,
        //             kizCount: x.kizCount,
        //             internalBarcode: x?.internalBarcode ?? undefined,
        //             incomeSource: x.incomeSource,
        //             isgRequest: x.isgRequest,
        //             bestBeforeRequest: x.bestBeforeRequest,
        //             retailPriceInStocks: x.retailPriceInStocks,
        //             kizs: e.data.items[0].kizes ?? [],
        //         })
        //     }).catch(() => {
        //         items.push({
        //             idGlobal: x.idGlobal as string,
        //             goodsName: x?.goods?.displayName ?? undefined,
        //             supplierCostInfo: x.supplierCostInfo,
        //             retailCostInfo: x.retailCostInfo,
        //             isKiz: x.isKiz,
        //             quantity: x.quantity,
        //             dateCreated: x.dateCreated,
        //             idLotExternalGlobal: x?.lot?.idGlobal ?? undefined,
        //             idGoodsExternalGlobal: x?.goods?.idGlobal ?? undefined,
        //             goodsCode: x.goodsCode,
        //             price: x.price,
        //             scPaid: x.scPaid,
        //             producerName: x.producerName ?? undefined,
        //             isGnvls: x.isGnvls,
        //             kizCount: x.kizCount,
        //             internalBarcode: x?.internalBarcode ?? undefined,
        //             incomeSource: x.incomeSource,
        //             isgRequest: x.isgRequest,
        //             bestBeforeRequest: x.bestBeforeRequest,
        //             retailPriceInStocks: x.retailPriceInStocks,
        //             kizs: [],
        //         })
        //     })
        // }
    }

    const addItems = async () => {
        const unresolvedPromises = RequestForMovement.data.items.map((x) => itemsPush(x));
        await Promise.all(unresolvedPromises);
    }

    addItems().then(() => callback(items))
}